module.exports = __webpack_public_path__ + "img/GAKUDEN.730de10a.svg";